import firebaseApp from '../../../services/firebaseService';
import { BaseHelper, IBase } from '../../base';
import firebase from 'firebase/app';

export interface IDamage extends IBase {
    name : string;

    localImages : Array<{
        name : string;
        path : string;
    }>;

    isActive : boolean;
}

export default class DamageHelper extends BaseHelper {
    public static readonly COLLECTION = 'damages';

    public static converter : firebase.firestore.FirestoreDataConverter<IDamage> = {
        fromFirestore: (snapshot) => {
            return DamageHelper.fromFirestore(snapshot);
        },
        toFirestore: (data : IDamage) => {
            return DamageHelper.toFirestore(data);
        },
    };

    protected static fromFirestore(snapshot : firebase.firestore.DocumentSnapshot) : IDamage {
        const result = super.fromFirestore(snapshot);
        const data = snapshot.data();

        if (!data) throw new Error('Does not exist!');
        if (!result) throw new Error('Does not exist!');

        return {
            ...data as IDamage,
            ...result,
            localImages: data.localImages ?? [],
            isActive: data.isActive ?? true,
        };
    }
    protected static toFirestore(data : IDamage) {
        const result = super.toFirestore(data);

        const { id: _, ...rest } = data;
        return {
            ...rest,
            ...result,
        };
    }

    public static collection() {
        return firebaseApp.firestore().collection(this.COLLECTION).withConverter(this.converter);
    }

    public static save(insect : IDamage) {
        if (insect.id) {
            return this.collection().doc(insect.id).set(insect);
        }

        return this.collection().doc().set(insect);
    }
}